/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { MAXIMUM_ITEM_DESCRIPTION_LENGTH } from '../../../utils/constants';
import { currencyNumberFormatter, maskAmount } from '../../../utils/formatting';

function GiftItem({ item, index }) {
  const {
    locale: { storeLocale },
    RL_ITEMVOID
  } = useSelector((state) => state);

  return (
    <section key={`${item?.Descriptions?.[0].Text}-${index}`}>
      <article className="justify-between">
        <p>{item?.voidFlag && (`<${RL_ITEMVOID}>`)}</p>
      </article>
      <article className="justify-between">
        <p>{
                ['es-AR', 'th-TH'].includes(storeLocale) && `${item?.Quantity?.Quantity} `
              }{
                item?.Descriptions?.find((i) => i.TypeCode === 'Short')?.Text.slice(0, MAXIMUM_ITEM_DESCRIPTION_LENGTH)
                || item?.Descriptions?.find((i) => i.TypeCode === 'Long')?.Text.slice(0, MAXIMUM_ITEM_DESCRIPTION_LENGTH)
                || 'UNNAMED ITEM'
              }
        </p>
        <p>{maskAmount(currencyNumberFormatter(
          storeLocale,
          parseFloat(item?.RegularSalesUnitPrice?.Amount).toFixed(2).slice(-3),
        ))}
        </p>
      </article>
      <article className="justify-between">
        <p className="pl2-sm">{item?.Item.ID}</p>
        <p />
      </article>
      <><br /><br /></>
    </section>
  );
}

GiftItem.defaultProps = {
  index: 0,
  item: {}
};

GiftItem.propTypes = {
  index: PropTypes.number,
  item: PropTypes.shape(),
};

export default GiftItem;
